'use client';

import * as React from 'react';
import {Input} from '@purpose/ui/components/input/input';
import {Button} from '@purpose/ui/components/button/button';
import {Search, Filter} from 'lucide-react';
import {cn} from '@purpose/ui/lib/utils';

export interface SearchWithFilterButtonProps {
  searchProps: {
    placeholder?: string;
    value?: string;
    onChange?: (value: string) => void;
    onInputChange?: (value: string) => void;
    onEnterPress?: () => void;
    onBlur?: () => void;
    blurOnSelect?: boolean;
    results?: any[];
  };
  filterButtonProps?: {
    text: string;
    onClick?: () => void;
  };
  onFilterClick?: () => void;
  className?: string;
}

const SearchWithFilterButton = ({
  searchProps,
  filterButtonProps,
  onFilterClick,
  className
}: SearchWithFilterButtonProps) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      searchProps.onEnterPress?.();
    }
  };

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className="relative flex-1">
        <Search className="absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-gray-400" />
        <Input
          placeholder={searchProps.placeholder}
          value={searchProps.value}
          onChange={e => {
            searchProps.onChange?.(e.target.value);
            searchProps.onInputChange?.(e.target.value);
          }}
          onKeyDown={handleKeyDown}
          onBlur={searchProps.onBlur}
          className="pl-10 text-sm"
        />
      </div>
      <Button
        variant="secondary"
        size="sm"
        onClick={filterButtonProps?.onClick || onFilterClick}
        className="flex h-10 items-center gap-2"
        aria-label="Filter"
      >
        <Filter className="h-4 w-4" />
        {filterButtonProps?.text}
      </Button>
    </div>
  );
};

export {SearchWithFilterButton};
